import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  title: {
    //textAlign: "left",
    color: "#098B8B",
    fontSize: "24px",
    // display: "flex",
    // alignItems: "center",
    //margin: "10px auto",
    //marginBottom: "30px",
    paddingLeft: "17px",
  },
}));

function Title(props) {
  const classes = useStyles();
  return <div className={classes.title}>{props.text}</div>;
}
export default Title;
